import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { TracksEffects } from './effects/tracks.effects';
import { PointsEffects } from './effects/points.effects';
import { DrivingEffects } from './effects/driving.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('tracksState', reducers),
    EffectsModule.forFeature([
      TracksEffects,
      PointsEffects,
      DrivingEffects
    ])
  ]
})
export class TracksStoreModule {}
